import { useCallback } from "react"
import { useAuthStore } from "@/stores/auth-store"

export function usePermissions() {
  const user = useAuthStore((state) => state.user)

  const hasPermission = useCallback(
    (slug: string): boolean => {
      if (!user?.roles) return false
      if (user.roles.some((role) => role.slug === "admin")) return true
      return user.roles.some((role) =>
        role.permissions?.some((p) => p.slug === slug)
      )
    },
    [user]
  )

  const hasAnyPermission = useCallback(
    (slugs: string[]): boolean => {
      return slugs.some((slug) => hasPermission(slug))
    },
    [hasPermission]
  )

  const hasAllPermissions = useCallback(
    (slugs: string[]): boolean => {
      return slugs.every((slug) => hasPermission(slug))
    },
    [hasPermission]
  )

  return { hasPermission, hasAnyPermission, hasAllPermissions }
}
